module.exports = __webpack_public_path__ + "static/media/competencies.98280675.png";